import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'reactstrap';
import { useSelector } from 'react-redux';

import { APP_CURRENCY_NAME, DA_CATEGORIES, S25_SLUGS } from 'config/constants';

import BeforeBuy from './elements/BeforeBuy/BeforeBuy';
import ProductDescriptionTabs from './elements/ProductDescriptionTabs/ProductDescriptionTabs';
import SlideShowGallery from './elements/SlideShow/SlideShow';
// import SlideShowMobileItem from './elements/SlideShow/SlideShowMobileItem';
import AfterBuy from './elements/AfterBuy/AfterBuy';
import ModalMessage from './elements/ModalMessage/ModalMessage';
import GetInTouch from 'screens/Home/components/GetInTouch/GetInTouch';
import CustomLinearProgress from 'containers/App/components/Loading/CustomLinearProgress';
import ElfsightWidget from 'components/ElfsightWidget/ElfsightWidget';
import FAQ from './elements/FAQ/FAQ';

import { storeUserEvent } from 'api/user';

import styles from './Product.module.scss';
import { Skeleton } from 'antd';
import Deals from '../Deals/DealsScreen';
import { trackKlaviyoEvent } from 'api/tracking';

ProductScreen.propTypes = {
    product: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    colors: PropTypes.array.isRequired,
    setColors: PropTypes.func,
    token: PropTypes.string.isRequired,
    handleRiseTicket: PropTypes.func,
    submitLoading: PropTypes.bool,
    recentProducts: PropTypes.array,
    isOrdered: PropTypes.bool,
    order: PropTypes.any,
    selectedRentalPeriod: PropTypes.object,
    setSelectedRentalPeriod: PropTypes.func,
    changeRentalTerms: PropTypes.func,
    handleBuyNow: PropTypes.func,
    handleReturnOrder: PropTypes.func,
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    messageType: PropTypes.string,
    isOpenFirst: PropTypes.bool,
    setIsOpenFirst: PropTypes.func,
    isOpenSecond: PropTypes.bool,
    setIsOpenSecond: PropTypes.func,
    componnetType: PropTypes.any,
    setComponnetType: PropTypes.func,
    riseTicket: PropTypes.object,
    setRiseTicket: PropTypes.func,
    returnOrderType: PropTypes.string,
    setReturnOrderType: PropTypes.func,
    singpassStatus: PropTypes.string,
    attribute: PropTypes.array,
    setAttribute: PropTypes.func,
    selectedColor: PropTypes.object,
    setSelectedColor: PropTypes.func,
    selectedStorage: PropTypes.object,
    setSelectedStorage: PropTypes.func,
    images: PropTypes.array,
    similarProducts: PropTypes.array,
    selectedDeals: PropTypes.object,
    deals: PropTypes.array,
    isDeal: PropTypes.bool,
    colorsGallery: PropTypes.array.isRequired,
    isAuthed: PropTypes.bool,
    deal: PropTypes.object,
    maxTradeInValue: PropTypes.number,
    isProductDA: PropTypes.bool
};

function ProductScreen({
    loading,
    product,
    colors,
    setColors,
    token,
    handleRiseTicket,
    submitLoading,
    isOrdered,
    order,
    selectedRentalPeriod,
    setSelectedRentalPeriod,
    changeRentalTerms,
    handleBuyNow,
    handleReturnOrder,
    isOpen,
    setIsOpen,
    messageType,
    isOpenFirst,
    setIsOpenFirst,
    isOpenSecond,
    setIsOpenSecond,
    componnetType,
    setComponnetType,
    riseTicket,
    setRiseTicket,
    returnOrderType,
    setReturnOrderType,
    singpassStatus,
    attribute,
    setAttribute,
    selectedColor,
    setSelectedColor,
    selectedStorage,
    setSelectedStorage,
    images,
    colorsGallery,
    isAuthed,
    isDeal = false,
    deal,
    maxTradeInValue,
    isProductDA
}) {
    const [, setSelectedRentalPeriods] = useState({});
    const { profile } = useSelector((state) => ({ profile: state.auth.profile }));
    const [enableButton, setEnableButton] = useState(false);

    const isEligible = () => {
        if (isAuthed && profile?.singpass_status === 'verified') {
            return !('eligible' in product) || (selectedStorage ? selectedStorage.item.eligible : product.eligible);
        }

        return true;
    };

    // const isStudentPriceAvailable = (product) => {
    //     let studentObj = null;

    //     if (product?.rental_period?.length > 0) {
    //         studentObj = product?.rental_period?.find(rp => rp?.user_type === 'b2s');
    //     }

    //     return studentObj !== undefined && studentObj !== null;
    // };

    // const addToCart = (rentalPeriod, product) => {
    //     localStorage.setItem('products', JSON.stringify([product]));

    //     if (isAuthed) {
    //         const payload = {
    //             toggle_event_called: true,
    //             data: rentalPeriod
    //         };
    //         const localStorageAccType = localStorage.getItem('is_student');

    //         if (!isStudentPriceAvailable(product)) {
    //             if (localStorageAccType === null) {
    //                 localStorage.setItem('is_student', profile?.is_student ? 'b2s' : 'b2c');
    //             }

    //             if (toggleAddToCartEvent) {
    //                 dispatch(toggleAddToCartEventFromStickyBottomBar(false));
    //             } else {
    //                 dispatch(toggleAddToCartEventFromStickyBottomBar(true));
    //             }

    //             dispatch(triggerAddToCartEventFromOutside(payload));

    //             localStorage.setItem('previousProductPage', location.pathname);

    //             return;
    //         }

    //         if (localStorageAccType !== null) {
    //             // eslint-disable-next-line default-case
    //             switch (localStorageAccType) {
    //                 case 'b2s':
    //                     if (rentalPeriod?.user_type === 'b2c') {
    //                         notify('Uh oh ! You are eligible for the student saver plan...', notifType.DANGER, 5000);
    //                     } else {
    //                         if (toggleAddToCartEvent) {
    //                             dispatch(toggleAddToCartEventFromStickyBottomBar(false));
    //                         } else {
    //                             dispatch(toggleAddToCartEventFromStickyBottomBar(true));
    //                         }

    //                         dispatch(triggerAddToCartEventFromOutside(payload));
    //                     }

    //                     break;
    //                 case 'b2c':
    //                     if (rentalPeriod?.user_type === 'b2s') {
    //                         notify('Uh oh ! You are eligible for the standard plan...', notifType.DANGER, 5000);
    //                     } else {
    //                         if (toggleAddToCartEvent) {
    //                             dispatch(toggleAddToCartEventFromStickyBottomBar(false));
    //                         } else {
    //                             dispatch(toggleAddToCartEventFromStickyBottomBar(true));
    //                         }

    //                         dispatch(triggerAddToCartEventFromOutside(payload));
    //                     }

    //                     break;
    //             }
    //         } else {
    //             const userType = profile?.is_student ? 'b2s' : 'b2c';

    //             // eslint-disable-next-line default-case
    //             switch (rentalPeriod?.user_type) {
    //                 case 'b2c':
    //                     if (userType === 'b2s') {
    //                         notify('Uh oh ! You are eligible for the student saver plan...', notifType.DANGER, 5000);
    //                     } else {
    //                         localStorage.setItem('is_student', profile?.is_student ? 'b2s' : 'b2c');

    //                         if (toggleAddToCartEvent) {
    //                             dispatch(toggleAddToCartEventFromStickyBottomBar(false));
    //                         } else {
    //                             dispatch(toggleAddToCartEventFromStickyBottomBar(true));
    //                         }

    //                         dispatch(triggerAddToCartEventFromOutside(payload));
    //                     }

    //                     break;
    //                 case 'b2s':
    //                     if (userType === 'b2c') {
    //                         notify('Uh oh ! You are eligible for the standard plan...', notifType.DANGER, 5000);
    //                     } else {
    //                         localStorage.setItem('is_student', profile?.is_student ? 'b2s' : 'b2c');

    //                         if (toggleAddToCartEvent) {
    //                             dispatch(toggleAddToCartEventFromStickyBottomBar(false));
    //                         } else {
    //                             dispatch(toggleAddToCartEventFromStickyBottomBar(true));
    //                         }

    //                         dispatch(triggerAddToCartEventFromOutside(payload));
    //                     }

    //                     break;
    //             }

    //             localStorage.setItem('previousProductPage', location.pathname);
    //         }
    //     } else {
    //         if (toggleAddToCartEvent) {
    //             dispatch(toggleAddToCartEventFromStickyBottomBar(false));
    //         } else {
    //             dispatch(toggleAddToCartEventFromStickyBottomBar(true));
    //         }

    //         localStorage.setItem('is_student', rentalPeriod?.user_type);
    //         localStorage.setItem('previousProductPage', location.pathname);
    //     }
    // };

    // if isOrdered && mobile view, scroll to #manageSubscription

    useEffect(() => {
        isOrdered && !loading && window.innerWidth < 992 &&
            document.getElementById('manageSubscription')?.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }, [isOrdered, loading]);

    useEffect(() => {
        if (product && product.id) {
            const triggerUserEvent = async () => {
                const payload = {
                    event: 'product_details',
                    product_id: product.id
                };

                await storeUserEvent(payload);
            };

            trackKlaviyoEvent('product_pg_visit', {
                email: profile.email,
                user_id: profile.user_id,
                ecommerce: {
                    currency: 'SGD',
                    value: Math.round(product.total),
                    items: [
                        {
                            item_id: product.id,
                            item_name: product.name,
                            item_brand: 'Samsung',
                            item_category: product.category.name,
                            item_category2: selectedColor,
                            item_category3: selectedStorage,
                            item_variant: selectedRentalPeriod,
                            price: Math.round(product.total)
                        }
                    ]
                }
            });

            triggerUserEvent();
        }
    }, [product]);

    useEffect(() => {
        if (attribute != null && colors != null && selectedStorage != null && selectedColor != null && product != null) {
            const updatedAttributes = attribute.map(att => {
                if (att?.item?.id === selectedStorage?.item?.id) {
                    const hasMatchingColor = colors.some(color => {
                        const itemToFind = product?.internal_asset_codes?.find(asset => (
                            asset?.product_attribute_value_id === att?.item?.id &&
                            asset?.color_id === color.value
                        ));

                        return itemToFind?.in_stock && color?.value === selectedColor?.value;
                    });

                    if (hasMatchingColor) {
                        setEnableButton(true);
                    } else {
                        setEnableButton(false);
                    }

                    return hasMatchingColor ? { ...att, stock: 1 } : { ...att, stock: 0 };
                } else {
                    const newAtt = { ...att, stock: product?.internal_asset_codes && product?.internal_asset_codes.filter(i => i?.product_attribute_value_id === att?.value)[0]?.in_stock };

                    // delete newAtt.stock;

                    return newAtt;
                }
            });

            const updatedColors = colors.map(color => {
                const itemToFind = product?.internal_asset_codes?.find(asset => (
                    asset?.color_id === color?.value &&
                    asset?.product_attribute_value_id === selectedStorage?.item?.id
                ));

                return itemToFind ? { ...color, stock: itemToFind?.in_stock } : color;
            });

            if (JSON.stringify(attribute) !== JSON.stringify(updatedAttributes)) {
                setAttribute(updatedAttributes);
            }

            if (JSON.stringify(colors) !== JSON.stringify(updatedColors)) {
                setColors(updatedColors);
            }
        }
    }, [attribute, colors, selectedStorage, selectedColor, product, setAttribute, setColors, setSelectedColor]);

    return (loading
        ? <div className={styles.loading}>
            <CustomLinearProgress loading={loading} />
            <p className='p-3'>
                <Skeleton.Button active={true} block={true} className={styles.slide_show__skeleton} />
                <br />
                <br />
                <Skeleton.Button active={true} block={true} className={[styles.subTitle_skeleton, styles.skeleton_hight]} />
                <br />
                <br />
                <Skeleton.Button active={true} block={true} className={[styles.title_skeleton, styles.skeleton_hight]} />
                <br />
                <br />
            </p>
        </div> : product.name ? (
            <>
                <div className={'product__detail-container'}>
                    <div className={styles.top}>
                        {!order && <div className={styles.top__slideshow}>
                            <SlideShowGallery
                                eligible={isEligible()}
                                slides={images}
                                selectedColor={selectedColor}
                                product={product}
                                isProductDA={DA_CATEGORIES.includes(product?.category?.name)}/>
                        </div>}
                        <div className={`container ${styles.top__details}`} id='manageSubscription'>
                            {(
                                !isOrdered && !isDeal
                                    ? <BeforeBuy
                                        images={images}
                                        selectedColor={selectedColor}
                                        setSelectedColor={setSelectedColor}
                                        selectedStorage={selectedStorage}
                                        setSelectedStorage={setSelectedStorage}
                                        selectedRentalPeriod={selectedRentalPeriod}
                                        setSelectedRentalPeriod={setSelectedRentalPeriod}
                                        attribute={attribute}
                                        singpassStatus={singpassStatus}
                                        product={product}
                                        rentalOptions={product.rental_period.length !== 0 ? product.rental_period : []}
                                        token={token}
                                        colors={colors}
                                        currency={APP_CURRENCY_NAME}
                                        title={product.name}
                                        price={product.rental_period[product.rental_period.length - 1].price}
                                        colorsGallery={colorsGallery}
                                        priceDetails={'/mo'}
                                        isAuthed={isAuthed}
                                        setSelectedRentalPeriods={setSelectedRentalPeriods}
                                        enableButton={enableButton}
                                        maxTradeInValue={maxTradeInValue}
                                        isProductDA={isProductDA}/>

                                    : (
                                        isDeal
                                            ? <Deals
                                                images={images}
                                                selectedColor={selectedColor}
                                                setSelectedColor={setSelectedColor}
                                                selectedStorage={selectedStorage}
                                                setSelectedStorage={setSelectedStorage}
                                                selectedRentalPeriod={selectedRentalPeriod}
                                                setSelectedRentalPeriod={setSelectedRentalPeriod}
                                                attribute={attribute}
                                                singpassStatus={singpassStatus}
                                                product={product}
                                                rentalOptions={product.rental_period.length !== 0 ? product.rental_period : []}
                                                token={token}
                                                colors={colors}
                                                currency={APP_CURRENCY_NAME}
                                                title={product.name}
                                                price={product.rental_period[product.rental_period.length - 1].price}
                                                colorsGallery={colorsGallery}
                                                priceDetails={'/mo'}
                                                isAuthed={isAuthed}
                                                setSelectedRentalPeriods={setSelectedRentalPeriods}
                                                enableButton={enableButton}
                                                deal={deal}
                                                maxTradeInValue={maxTradeInValue}
                                                isProductDA={isProductDA}/>
                                            : <AfterBuy
                                                returnOrderType={returnOrderType}
                                                setReturnOrderType={setReturnOrderType}
                                                riseTicket={riseTicket}
                                                setRiseTicket={setRiseTicket}
                                                isOpenFirst={isOpenFirst}
                                                setIsOpenFirst={setIsOpenFirst}
                                                isOpenSecond={isOpenSecond}
                                                setIsOpenSecond={setIsOpenSecond}
                                                componnetType={componnetType}
                                                setComponnetType={setComponnetType}
                                                order={order}
                                                handleReturnOrder={handleReturnOrder}
                                                handleBuyNow={handleBuyNow}
                                                selectedRentalPeriod={selectedRentalPeriod}
                                                setSelectedRentalPeriod={setSelectedRentalPeriod}
                                                changeRentalTerms={changeRentalTerms}
                                                rentalOptions={product.rental_period}
                                                submitLoading={submitLoading}
                                                product={product}
                                                handleRiseTicket={handleRiseTicket}
                                                isProductDA={isProductDA}/>
                                    )
                            )}
                        </div>
                    </div>
                    <div className={`container ${styles.middle}`}>
                        {(!isOrdered) &&
                            <>
                                <div className={styles.middle__description}>
                                    <div>
                                        <ProductDescriptionTabs
                                            description={product?.description_html}
                                            specifications={product?.attributes.length !== 0 && product?.attributes?.specifications && product?.attributes?.specifications?.values ? product?.attributes?.specifications?.values : []}
                                            box={(product?.attributes.length !== 0 && product?.attributes?.inside_box && product?.attributes?.inside_box?.values) ? product?.attributes?.inside_box?.values : []} />
                                    </div>
                                </div>
                            </>}
                    </div>

                    <div className={styles.elfsight_google_reviews}>
                        <ElfsightWidget type='google-review' />
                    </div>

                    <Modal
                        isOpen={isOpen}
                        toggle={() => setIsOpen(false)}
                        className={styles.modal}>
                        <ModalMessage messageType={messageType} />
                    </Modal>

                    {!isOrdered && <div className={styles.faq__container}>
                        <div className='container'>
                            { !isProductDA && <FAQ /> }
                            <GetInTouch />
                            {(S25_SLUGS.includes(product.slug) || product.slug === 'samsung-galaxy-s25-edge') &&
                                <div className={styles.S25Durability}>
                                    <p>Visit <a href='http://samsung.com/' target='_blank' rel='noreferrer'>Samsung.com</a> for more information on features and disclaimers.</p>
                                    {/* <S25Durability slug={product.slug} /> */}
                                </div>}
                        </div>
                    </div>}
                </div>
            </>
        ) : '');
}

export default ProductScreen;
